import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Canonicals and og:url always point at the apex host, regardless of the
// host the page happens to be viewed on (www, preview) — site audit 2026-10-23.
const ORIGIN = "https://gatemate.net";

/**
 * Per-route SEO: title, description, canonical, OG/Twitter, and optional JSON-LD.
 * `robots` (e.g. "noindex, follow") is applied for the route and removed on
 * unmount so it never leaks onto other pages.
 */
export function useSEO({ title, description, path = "/", image, jsonLd, robots }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("name", "description", description);
    setCanonical(`${ORIGIN}${path}`);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${ORIGIN}${path}`);
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);

    let robotsEl;
    if (robots) {
      robotsEl = document.querySelector('meta[name="robots"]');
      if (!robotsEl) {
        robotsEl = document.createElement("meta");
        robotsEl.setAttribute("name", "robots");
        robotsEl.setAttribute("data-dynamic", "true");
        document.head.appendChild(robotsEl);
      }
      robotsEl.setAttribute("content", robots);
    }

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-dynamic", "true");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script) document.head.removeChild(script);
      if (robotsEl) robotsEl.remove();
    };
  }, [title, description, path, image, jsonLd, robots]);
}
